import React, {useEffect, useMemo, useState} from 'react';
import LCVHelpButton from './LCVHelpButton';
import {shuffleIndicesDeterministic} from './questionUtils';

const MARKERS = ['A', 'B', 'C', 'D'];

const WorkbookOptionsPhase = ({
  workbook,
  workbookState,
  onSubmit,
  onContinue,
  continueDisabled = false,
}) => {
  const [selected, setSelected] = useState(null);
  const wb = workbook;
  const submitted = workbookState.submitted;
  const submittedIdx = workbookState.selectedOption;

  // workbook.options is index-aligned with workbook.optionFeedback (and the
  // feedback audio ids), so we can't shuffle the underlying arrays. Instead
  // we shuffle a presentation order of original indices and only translate
  // the display click back to the original index right before we submit —
  // the reducer/selectors continue to see the original index they expect.
  const displayOrder = useMemo(() => {
    const length = Array.isArray(wb?.options) ? wb.options.length : 0;
    if (length === 0) return [];
    return shuffleIndicesDeterministic(
      length,
      `workbook::${wb?.exercise || ''}::${wb?.correctAnswer || ''}`,
    );
  }, [wb?.options, wb?.exercise, wb?.correctAnswer]);

  useEffect(() => {
    setSelected(null);
  }, [wb?.exercise]);

  const handleSelect = (originalIdx) => {
    if (submitted) return;
    setSelected(originalIdx);
  };

  const handleSubmit = () => {
    if (selected === null) return;
    onSubmit(selected);
  };

  const getOptionClass = (idx) => {
    if (!submitted) {
      return idx === selected ? 'lcv-option-selected' : '';
    }
    if (idx === submittedIdx) {
      const isCorrect = wb.options[idx] === wb.correctAnswer;
      return isCorrect ? 'lcv-option-correct' : 'lcv-option-incorrect';
    }
    if (wb.options[idx] === wb.correctAnswer) {
      return 'lcv-option-correct';
    }
    return '';
  };

  return (
    <div className="lcv-work-panel">
      <LCVHelpButton phase="workbook_options" />
      <div className="lcv-work-badge">
        <span className="lcv-work-dot" />
        WORKBOOK REVIEW
      </div>

      <div className="lcv-check-question">{wb.exercise}</div>

      <div className="lcv-options">
        {displayOrder.map((originalIdx, displayIdx) => (
          <button
            key={originalIdx}
            className={`lcv-option ${getOptionClass(originalIdx)}`}
            onClick={() => handleSelect(originalIdx)}
            disabled={submitted}
          >
            <span className="lcv-option-marker">{MARKERS[displayIdx]}</span>
            <span>{wb.options[originalIdx]}</span>
          </button>
        ))}
      </div>

      {/* {submitted && (
        <div className={`lcv-feedback ${wb.options[submittedIdx] === wb.correctAnswer ? 'lcv-fb-correct' : 'lcv-fb-incorrect'}`}>
          <span>{wb.options[submittedIdx] === wb.correctAnswer ? '✅' : '❌'}</span>
          <span>{wb.optionFeedback[submittedIdx]}</span>
        </div>
      )} */}

      {!submitted && (
        <button className="lcv-btn-primary lcv-btn-full" onClick={handleSubmit} disabled={selected === null}>
          That's my answer →
        </button>
      )}
      {submitted && (
        <button
          className="lcv-btn-primary lcv-btn-full"
          onClick={onContinue}
          disabled={continueDisabled}>
          Continue →
        </button>
      )}
    </div>
  );
};

export default WorkbookOptionsPhase;
